var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "h-full flex flex-col overflow-hidden gap-[10px] bg-white p-[20px]"
  }, [_c('div', {
    staticClass: "audit-search-area rounded-md flex flex-col gap-2"
  }, [_c('Alert', {
    scopedSlots: _vm._u([{
      key: "desc",
      fn: function () {
        return [_vm._v(`${$t("94tncu1a", "审计日志记录了组织内主要业务的变更历史，你可使用条件筛选来查找具体事件，数据存储时效180天")} `)];
      },
      proxy: true
    }])
  }, [_vm._v(` ${$t("f8bu83", "提示：")} `)]), _c('main', {
    staticClass: "grid grid-cols-3 gap-4"
  }, [_c('div', {
    staticClass: "flex items-center gap-2"
  }, [_c('TextEllipsis', {
    staticClass: "label max-w-[80px] min-w-[80px]",
    attrs: {
      "text": $t("7tw80w5", "选择日期:"),
      "textAlign": "right"
    }
  }), _c('DatePicker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "editable": false,
      "options": _vm.datePickerOptions,
      "clearable": false
    },
    on: {
      "on-change": _vm.handleDateRangeChange
    },
    model: {
      value: _vm.searchParams.dateRange,
      callback: function ($$v) {
        _vm.$set(_vm.searchParams, "dateRange", $$v);
      },
      expression: "searchParams.dateRange"
    }
  })], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showOrgSelect,
      expression: "showOrgSelect"
    }],
    staticClass: "flex items-center gap-2"
  }, [_c('TextEllipsis', {
    staticClass: "label max-w-[80px] min-w-[80px] text-right",
    attrs: {
      "textAlign": "right",
      "text": $t("erv5mn5", "组织单位:")
    }
  }), _c('Select', {
    staticClass: "firefox-select-focus-fix",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": $t("en402", "全部"),
      "clearable": "",
      "filterable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.handleQueryChange
    },
    model: {
      value: _vm.searchParams.unitId,
      callback: function ($$v) {
        _vm.$set(_vm.searchParams, "unitId", $$v);
      },
      expression: "searchParams.unitId"
    }
  }, _vm._l(_vm.unitList, function (item) {
    return _c('Option', {
      key: item.unitId,
      attrs: {
        "value": item.unitId,
        "label": `${item.name}（${item.code}）`
      }
    }, [_vm._v(" " + _vm._s(item.name) + "（" + _vm._s(item.code) + "） ")]);
  }), 1)], 1), _c('div', {
    staticClass: "flex items-center gap-2"
  }, [_c('TextEllipsis', {
    staticClass: "label max-w-[80px] min-w-[80px]",
    attrs: {
      "text": $t("d1oz734", "操作人:"),
      "textAlign": "right"
    }
  }), _c('Select', {
    staticClass: "firefox-select-focus-fix",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": $t("en402", "全部"),
      "clearable": "",
      "filterable": "",
      "multiple": "",
      "max-tag-count": 2
    },
    on: {
      "on-change": _vm.handleQueryChange
    },
    model: {
      value: _vm.searchParams.operatorUserIds,
      callback: function ($$v) {
        _vm.$set(_vm.searchParams, "operatorUserIds", $$v);
      },
      expression: "searchParams.operatorUserIds"
    }
  }, _vm._l(_vm.auditMembers, function (item) {
    return _c('Option', {
      key: item.userId,
      attrs: {
        "value": item.userId
      }
    }, [_vm._v(" " + _vm._s(item.userName) + " ")]);
  }), 1)], 1), _c('div', {
    staticClass: "flex items-center gap-2"
  }, [_c('div', {
    staticClass: "label min-w-[80px]"
  }, [_c('TextEllipsis', {
    staticClass: "label max-w-[80px] min-w-[80px]",
    attrs: {
      "text": $t("fe8ore5", "功能模块:"),
      "textAlign": "right"
    }
  })], 1), _c('Select', {
    staticClass: "firefox-select-focus-fix",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": $t("en402", "全部"),
      "clearable": "",
      "filterable": ""
    },
    on: {
      "on-change": _vm.handleModuleChange
    },
    model: {
      value: _vm.searchParams.module,
      callback: function ($$v) {
        _vm.$set(_vm.searchParams, "module", $$v);
      },
      expression: "searchParams.module"
    }
  }, _vm._l(_vm.moduleList, function (item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1), _c('div', {
    staticClass: "flex items-center gap-2"
  }, [_c('TextEllipsis', {
    staticClass: "label max-w-[80px] min-w-[80px]",
    attrs: {
      "text": $t("xgddlr5", "事件类型:"),
      "textAlign": "right"
    }
  }), _c('Select', {
    staticClass: "firefox-select-focus-fix",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": $t("en402", "全部"),
      "clearable": "",
      "filterable": "",
      "multiple": "",
      "max-tag-count": 1
    },
    on: {
      "on-change": _vm.handleQueryChange
    },
    model: {
      value: _vm.searchParams.events,
      callback: function ($$v) {
        _vm.$set(_vm.searchParams, "events", $$v);
      },
      expression: "searchParams.events"
    }
  }, _vm._l(_vm.eventTypeList, function (item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(" " + _vm._s(item.name) + " ")]);
  }), 1)], 1), _c('div', {
    staticClass: "flex items-end justify-end gap-2",
    staticStyle: {
      "grid-column": "3"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleExport
    }
  }, [_vm._v(` ${$t("g3ge2", "导出")} `)]), _c('Button', {
    on: {
      "click": _vm.handleQueryChange
    }
  }, [_vm._v(` ${$t("ejix2", "刷新")} `)])], 1)])], 1), _c('div', {
    ref: "tableSection",
    staticClass: "audit-table-section flex-1 min-h-0 bg-white rounded-md flex flex-col"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "data": _vm.tableData,
      "loading": _vm.loading,
      "height": _vm.tableHeight,
      "scroll": "{ x: 'max-content' }"
    },
    scopedSlots: _vm._u([{
      key: "detailData",
      fn: function ({
        row
      }) {
        return [_c('p', {
          staticClass: "audit-detail-link",
          on: {
            "click": function ($event) {
              return _vm.showDetailData(row);
            }
          }
        }, [_vm._v(" " + _vm._s(row.eventResult) + " ")])];
      }
    }])
  }), _c('div', {
    ref: "pagination",
    staticClass: "audit-pagination bg-white pt-[15px] rounded-md flex justify-end items-center"
  }, [_c('Page', {
    attrs: {
      "total": _vm.total,
      "current": _vm.currentPage,
      "show-sizer": "",
      "show-total": ""
    },
    on: {
      "on-change": _vm.handlePageChange,
      "on-page-size-change": _vm.handlePageSizeChange
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };